import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Edit, Tick } from '../../helpers/icon-dictionary';
import styles from './index.scss';
import Button from '../button/index';
import { BOX_LIGHT } from '../button/variants';
import SvgIcon from '../svg-icon/svg-icon';
import messages from './messages';
import productEnum from '../../helpers/product-enum';

class AddGroupConfirmation extends Component {
    constructor(props) {
        super(props);
        this.handleOnClose = this.handleOnClose.bind(this);
        this.handleOnManageStudent = this.handleOnManageStudent.bind(this);
        this.handleOnChangeCourse = this.handleOnChangeCourse.bind(this);
    }

    handleOnChangeCourse = () => {
        const { addGroupAddedGroup, openChangeCourse } = this.props;
        openChangeCourse(addGroupAddedGroup.classroomId, addGroupAddedGroup.id);
        this.handleOnClose();
    }

    handleOnManageStudent = () => {
        const { handleOnManageStudents, classroomDetail, addGroupAddedGroup } = this.props;
        this.handleOnClose();
        handleOnManageStudents(classroomDetail.classroomId, classroomDetail.name, addGroupAddedGroup.id);
    }

    handleOnClose = () => {
        const { closeAddGroup } = this.props;
        closeAddGroup();
    }

    render() {
        const { classroomDetail, addGroupAddedGroup, intl, selectedProduct } = this.props;
        const { classroomGroups } = classroomDetail;
        const addedGroup = classroomGroups.find(x => x.id === addGroupAddedGroup.id);

        const courseName = !addedGroup ? '' : addedGroup.courseTitle;
        const upfCourseName = !addedGroup ? '' : addedGroup.upfCourseTitle;

        const isMatletica = (selectedProduct.id === productEnum.MATLETICA.id);
        const isMathletics = (selectedProduct.id === productEnum.MATHLETICS.id);

        return (
            <div>
                <div className={styles.addGroupComponent}>
                    <div className={styles.icon}>
                        <SvgIcon icon={Tick} />
                    </div>
                    <div className={styles.header}>
                        <span>{addGroupAddedGroup.name}</span> {intl.formatMessage(messages.createdAssigned)} <span>{courseName}</span>
                        {isMathletics && ' & '}
                        {isMathletics && <span>{upfCourseName}</span>}
                    </div>
                    <Button
                        handleOnClick={this.handleOnManageStudent}
                        icon={Edit}
                        label={intl.formatMessage(messages.manageStudent)}
                        variant={BOX_LIGHT} />
                    <Button
                        handleOnClick={this.handleOnChangeCourse}
                        hidden={isMatletica}
                        icon={Edit}
                        label={intl.formatMessage(messages.changeCourse)}
                        variant={BOX_LIGHT} />
                    <Button
                        handleOnClick={this.handleOnClose}
                        icon={Tick}
                        label={intl.formatMessage(messages.done)}
                        variant={BOX_LIGHT} />
                </div>
            </div>
        );
    }
}

AddGroupConfirmation.propTypes = {
    addGroupAddedGroup: PropTypes.object,
    classroomDetail: PropTypes.object,
    closeAddGroup: PropTypes.func,
    intl: intlShape.isRequired,
    openChangeCourse: PropTypes.func,
    handleOnManageStudents: PropTypes.func,
    selectedProduct: PropTypes.object
};

export default injectIntl(styleable(styles)(AddGroupConfirmation));




// WEBPACK FOOTER //
// ./app/components/add-group/confirmation.js